import { Component, OnInit } from '@angular/core';
import {Router} from '@angular/router';
import { DadosService } from '../../db/dados.service';

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.css']
})
export class MainComponent implements OnInit {

  constructor(private route:Router,private dados:DadosService) { }

  ngOnInit() {

  }
  getFornecedores(){
    return this.dados.getFornecedoresMaster();
  }

  doFornecedorClick(codigo){
    this.dados.regAnalytics(codigo,'publicidade','fornecedor',1);
    this.route.navigate(['/prod_fornec',codigo]);

  }

  getProdutosMaster(){
    return this.dados.getProdutosMaster();
  }
}
